import ReactGridLayout, { horizontalCompactor, useContainerWidth } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import { cn } from "../utils";
import { useDashboardContext } from "./context";
import type { DashboardProps } from "./shared";

export function DashboardWrapper({ children }: DashboardProps) {
	/** Context */
	const {
		layouts: { lg: layout },
	} = useDashboardContext();
	const { width, containerRef, mounted } = useContainerWidth();

	/** Render */
	return (
		<div
			className="w-full h-full overflow-y-auto overflow-x-hidden"
			ref={containerRef}
		>
			{mounted && (
				<ReactGridLayout
					width={width}
					className={cn("layout", "dashboard-grid")}
					gridConfig={{
						rowHeight: 275,
						cols: 6,
						containerPadding: [0, 0],
					}}
					layout={layout}
					compactor={horizontalCompactor}
				>
					{children}
				</ReactGridLayout>
			)}
		</div>
	);
}
